if (!customElements.get('predictive-search')) {
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();

      this.input = this.querySelector('input[type="search"]');
      this.resultsContainer = this.querySelector(
        '.js-results-container'
      );
      this.btnSubmit = this.querySelector('.js-btn-submit');
      this.btnClearText = this.querySelectorAll('.js-btn-clear-text');
      this.errorMessageContainer = this.querySelector(
        '.js-message-error'
      );
      this.errorMessageText =
        this.errorMessageContainer.querySelector('[data-text]');
      this.timeout = null;
      this.isOpen = false;
      this.drawer = this.closest('.js-drawer');

      var searchDrawerContent = document.querySelector('.drawer__content--search');
      var searchSuggestions = document.querySelector('.search-drawer__suggestions');

      // Nawa suggestions elements
      this.emptyState = document.getElementById('search-empty-state');
      this.recentSearches = document.getElementById('search-recent-searches');
      this.nawaSuggestions = document.getElementById('search-nawa-suggestions');
      this.nawaProducts = document.getElementById('search-nawa-products');

      this.input.addEventListener('input', e => {
        clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          const searchTerm = this.input.value.trim();

          if (searchTerm.length <= 0) {
            this.close();
            if (window.innerWidth < 990) {
              searchDrawerContent.style.height = 'auto';
            }
            if (searchSuggestions) {
              searchSuggestions.style.display = 'block';
            }
            // Show empty state with Nawa suggestions
            this.showEmptyState();
            return;
          }

          this.isOpen = true;
          this.getSearchResults(searchTerm);
          if (window.innerWidth <= 990) {
            searchDrawerContent.style.height = '100%';
          }
          if (searchSuggestions) {
            searchSuggestions.style.display = 'none';
          }
          // When searching: hide recent searches and products, keep Nawa suggestions visible
          this.showOnlyNawaSuggestions();
        }, 300);
      });

      this.input.addEventListener('keydown', e => {
        const isEscape = e.key === 'Escape';
        const isEnter = e.key === 'Enter';

        if (isEnter && this.input.value.trim()) {
          // Save search term to cookie before submitting
          const searchTerm = this.input.value.trim();
          this.saveRecentSearch(searchTerm);

          // Allow form to submit naturally when Enter is pressed
          const form = this.querySelector('form');
          if (form) {
            form.submit();
          }
          return;
        }

        if (!isEscape) {
          return;
        }

        if (!this.input.value) {
          if (this.drawer) {
            this.drawer.parentElement.parentElement.toggleDrawer();
          }

          return;
        }

        this.close();
      });

      this.btnSubmit.addEventListener('click', e => {
        // Save search term when clicking the search button
        if (this.input.value.trim()) {
          this.saveRecentSearch(this.input.value.trim());
        }
      });

      this.btnClearText.forEach(btn => {
        btn.addEventListener('click', e => {
          this.close();
          searchDrawerContent.style.height = 'auto';
          if (searchSuggestions) {
            searchSuggestions.style.display = 'block';
          }
          // Show empty state when clearing search
          this.showEmptyState();
        });
      });
    }

    showEmptyState() {
      // Show all sections: recent searches, Nawa suggestions, and Nawa products
      if (this.emptyState) {
        this.emptyState.style.display = 'block';
      }
      if (this.recentSearches) {
        this.recentSearches.style.display = 'block';
      }
      if (this.nawaSuggestions) {
        this.nawaSuggestions.style.display = 'block';
      }
      if (this.nawaProducts) {
        this.nawaProducts.style.display = 'block';
      }
    }

    hideEmptyState() {
      // Hide everything
      if (this.emptyState) {
        this.emptyState.style.display = 'none';
      }
    }

    showOnlyNawaSuggestions() {
      // Keep the empty state container visible
      if (this.emptyState) {
        this.emptyState.style.display = 'block';
      }
      // Hide recent searches
      if (this.recentSearches) {
        this.recentSearches.style.display = 'none';
      }
      // Keep Nawa suggestions visible
      if (this.nawaSuggestions) {
        this.nawaSuggestions.style.display = 'block';
      }
      // Hide Nawa products
      if (this.nawaProducts) {
        this.nawaProducts.style.display = 'none';
      }
    }

    async getSearchResults(searchTerm) {
      try {
        const response = await fetch(
          `${Shopify.routes.root}search/suggest?q=${searchTerm}&resources[type]=product,page,article,collection,query&resources[limit]=7&section_id=predictive-search&resources[options][fields]=title`
        );

        if (!this.isOpen) {
          return;
        }

        if (!response.ok) {
          const error = new Error(response.status);

          throw error;
        }

        const text = await response.text();
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector(
            '#shopify-section-predictive-search'
          ).innerHTML;

        this.resultsContainer.innerHTML = resultsMarkup;
        this.open();

        // Fetch dynamic suggestions for Nawa suggestions section after template renders
        this.fetchDynamicSuggestions(searchTerm);

        // new added product cards - quick cart triggers - set event listeners
        document.querySelector('quick-cart-drawer')?.initTriggers();

      } catch (error) {
        this.errorMessageText.textContent = error.message;
        this.errorMessageContainer.classList.remove('hidden');
      }
    }

    async fetchDynamicSuggestions(searchTerm) {
      try {
        const response = await fetch(
          `${Shopify.routes.root}search/suggest.json?q=${encodeURIComponent(searchTerm)}&resources[type]=product&resources[limit]=4&resources[options][fields]=title`
        );

        if (!response.ok) {
          return;
        }

        const data = await response.json();
        const products = data.resources?.results?.products || [];

        // Update Nawa suggestions with dynamic product data
        this.updateNawaSuggestions(products);

      } catch (error) {
        console.error('Error fetching dynamic suggestions:', error);
      }
    }

    updateNawaSuggestions(products) {
      // Find the Nawa suggestions list in the predictive search results
      const nawaSuggestionsList = this.resultsContainer?.querySelector('.predictive-search__links');

      if (!nawaSuggestionsList) {
        return;
      }

      // Clear existing suggestions
      nawaSuggestionsList.innerHTML = '';

      // Add dynamic product suggestions (max 4)
      const limitedProducts = products.slice(0, 4);

      if (limitedProducts.length > 0) {
        limitedProducts.forEach(product => {
          const listItem = document.createElement('li');
          listItem.className = 'predictive-search__links-item';

          const link = document.createElement('a');
          link.href = product.url;
          link.className = 'predictive-search__links-link';

          const span = document.createElement('span');
          span.setAttribute('aria-label', product.title);
          span.textContent = product.title;

          link.appendChild(span);
          listItem.appendChild(link);
          nawaSuggestionsList.appendChild(listItem);
        });
      } else {
        // Fallback: show current search term if no suggestions
        const listItem = document.createElement('li');
        listItem.className = 'predictive-search__links-item';

        const link = document.createElement('a');
        link.href = `${Shopify.routes.root}search?q=${encodeURIComponent(this.input.value.trim())}&options[fields]=title`;
        link.className = 'predictive-search__links-link';

        const span = document.createElement('span');
        span.textContent = this.input.value.trim();

        link.appendChild(span);
        listItem.appendChild(link);
        nawaSuggestionsList.appendChild(listItem);
      }
    }

    open() {
      this.classList.add('is-open');
      this.resultsContainer.classList.remove('hidden');
      this.errorMessageContainer.classList.add('hidden');
      this.btnSubmit.setAttribute('tabindex', '-1');
      this.btnClearText.forEach(btn => btn.removeAttribute('disabled'));
      // Hide empty state when showing search results
      this.hideEmptyState();
    }

    close() {
      this.isOpen = false;
      this.classList.remove('is-open');
      this.resultsContainer.classList.add('hidden');
      this.errorMessageContainer.classList.add('hidden');
      this.input.value = '';
      this.input.focus();
      this.btnSubmit.removeAttribute('tabindex');
      this.btnClearText.forEach(btn => btn.setAttribute('disabled', true));
      // Show empty state when closing
      this.showEmptyState();
    }

    // Cookie management for recent searches
    setCookie(name, value, days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      const expires = 'expires=' + date.toUTCString();
      document.cookie = name + '=' + encodeURIComponent(value) + ';' + expires + ';path=/;SameSite=Lax';
    }

    getCookie(name) {
      const nameEQ = name + '=';
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].trim();
        if (cookie.indexOf(nameEQ) === 0) {
          return decodeURIComponent(cookie.substring(nameEQ.length));
        }
      }
      return null;
    }

    getRecentSearches() {
      const cookieValue = this.getCookie('nawa_recent_searches');
      if (!cookieValue) return [];
      try {
        return JSON.parse(cookieValue);
      } catch (e) {
        return [];
      }
    }

    saveRecentSearch(term) {
      if (!term || !term.trim()) return;

      term = term.trim();
      let searches = this.getRecentSearches();

      // Remove duplicate if exists (case-insensitive)
      searches = searches.filter(search => search.toLowerCase() !== term.toLowerCase());

      // Add new search at the beginning
      searches.unshift(term);

      // Keep only the most recent 4 items
      searches = searches.slice(0, 4);

      // Save to cookie with 10-day expiry
      this.setCookie('nawa_recent_searches', JSON.stringify(searches), 10);
    }
  }

  customElements.define('predictive-search', PredictiveSearch);
}